import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import JobBackground from 'Assets/job-background.jpg';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkActiveSession } from 'Features/Auth/authSlice';
import { fetchEmployerCount } from 'Features/Organization/organizationSlice';
import { RootState } from 'Store';

const UserProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  .profile-settings-container {
    background: #fff;
    .profile-settings {
      padding: 46px 25px 76px 25px;
      display: flex;
      max-width: 1440px;
      width: 100%;
      margin: auto;
      flex-direction: column;
      .profile-management {
        width: 100%;
        @media screen and ${(props) => props.theme.breakpoints.lg} {
          width: 50%;
        }
        h2 {
          margin-top: 0;
          color: #252525;
          font-family: acumin-pro;
          font-size: 24px;
          letter-spacing: 0;
          line-height: 29px;
          font-weight: 400;
        }
      }
      .settings {
        .modal-button {
          color: #0a4ea2;
          font-family: acumin-pro;
          font-size: 14px;
          letter-spacing: 0;
          text-decoration: none;
          margin-bottom: 20px;
          &:hover {
            cursor: pointer;
          }
        }
        display: flex;
        width: 100%;
        padding-top: 50px;
        @media screen and ${(props) => props.theme.breakpoints.lg} {
          width: 50%;
          padding-top: 0;
        }
        flex-direction: column;
        @media screen and ${(props) => props.theme.breakpoints.lg} {
          margin-left: 60px;
        }
        h3 {
          color: #252525;
          font-family: acumin-pro;
          font-size: 18px;
          letter-spacing: 0;
          line-height: 22px;
          font-weight: 500;
          margin-top: 0;
          margin-bottom: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid #d6dce2;
        }
        a {
          color: #0a4ea2;
          font-family: acumin-pro;
          font-size: 14px;
          letter-spacing: 0;
          line-height: 17px;
          text-decoration: none;
          padding-bottom: 20px;
        }
      }
    }
  }
`;

const UserProfile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { employerCount } = useSelector(
    (state: RootState) => state.organization,
  );
  useEffect(() => {
    dispatch(checkActiveSession());
    dispatch(fetchEmployerCount());
  }, []);
  return (
    <UserProfileContainer>
      <div className="profile-settings-container">
        <div className="profile-settings">
          <h2>{t('employers-in-one-place', { count: employerCount })}</h2>
        </div>
      </div>
    </UserProfileContainer>
  );
};

export default UserProfile;
